import { render } from "./CashierNavbarComponent.vue?vue&type=template&id=2a414acc&scoped=true"
import script from "./CashierNavbarComponent.vue?vue&type=script&lang=js"
export * from "./CashierNavbarComponent.vue?vue&type=script&lang=js"

import "./CashierNavbarComponent.vue?vue&type=style&index=0&id=2a414acc&lang=scss&scoped=true"

import exportComponent from "/var/www/cose-cashier/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a414acc"]])

export default __exports__